module.exports = __webpack_public_path__ + "static/img/bigdata.d6b8f377.png";